/**
 * Structural type for location data - works with any GraphQL type that has these fields
 * (e.g., Location, EventLocation, etc.)
 */
type AddressFields = Readonly<{
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
}>;

export const cityAndState = (location?: AddressFields | null) => {
  if (location?.city && location.state) {
    return `${location.city}, ${location.state}`;
  }
  if (location?.state) {
    return location.state;
  } else {
    return '';
  }
};

export const addressStr = (location: AddressFields | null | undefined) => {
  let addressStr = '';
  if (location) {
    addressStr += `${location.address1 ? location.address1 + '.' : ''} ${location.state ? `${location.city},` : location.city} ${location.state} ${
      location.postalCode ? ',' + location.postalCode : ''
    }`;
  }
  return addressStr;
};
